import { NavigateBackLink } from '@exam-management/components';
import { useQSetReviewTask } from '@exam-management/qset-review-task-detail';
import { useParams } from '@exam-management/router';
import { PageHeader } from '@shared/components';
import { matchPath, Outlet, useLocation } from 'react-router-dom';

export default function ReviewResultLayout() {
  const location = useLocation();
  const { taskId, qSetId } = useParams('/my-task/qset-review/:taskId/qset/:qSetId/review-result');
  const { mainTaskDetail } = useQSetReviewTask();
  const qSetSubtask = mainTaskDetail.subtasks.find((subtask) => subtask.qsetId === qSetId);

  const getNavigateBackLink = () => {
    const isInReviewResultPage = matchPath(
      '/my-task/qset-review/:taskId/qset/:qSetId/review-result',
      location.pathname,
    );

    if (isInReviewResultPage) {
      return (
        <NavigateBackLink to='/my-task/qset-review/:taskId' params={{ taskId }} label='Back' />
      );
    }

    const isInExamDetailsPage = matchPath(
      '/my-task/qset-review/:taskId/qset/:qSetId/review-result/exam-details',
      location.pathname,
    );

    if (isInExamDetailsPage) {
      return (
        <NavigateBackLink
          to='/my-task/qset-review/:taskId/qset/:qSetId/review-result'
          params={{ taskId, qSetId }}
          label='Back'
        />
      );
    }

    return <NavigateBackLink to='/' label='Back' />;
  };

  return (
    <>
      <PageHeader
        title={`ชุดข้อสอบ: ${qSetSubtask?.qsetCode}`}
        linkAdornment={<>{getNavigateBackLink()}</>}
      />
      <Outlet />
    </>
  );
}
